import { Star } from "lucide-react";

/**
 * Star rating display used on vendor cards.
 * Extracted from MarketplaceHome.jsx (Session 30, PD-2).
 */
export function StarRating({ value, count }) {
  return (
    <div className="mp-rating">
      <Star size={11} fill="currentColor" />
      <span>{value.toFixed(1)}</span>
      <span style={{ color: "rgba(245,240,232,0.35)", fontSize: 11 }}>({count})</span>
    </div>
  );
}
